import { useEffect } from "react";

const DEFAULTS = {
    title: "EIGOO Books Hub — Sovereign Commander",
    description:
        "EIGOO Books Hub — Digital Publishing & Comic Series. Read Sovereign Commander, our flagship animated comic, in cinematic page mode or scroll-driven motion-comic mode.",
    image: "/og-image.png",
};

function setMeta(selector, attr, value) {
    if (typeof document === "undefined") return;
    let el = document.head.querySelector(selector);
    if (!el) {
        el = document.createElement("meta");
        // selector looks like meta[name="foo"] or meta[property="foo"]
        const m = selector.match(/meta\[(name|property)="([^"]+)"\]/);
        if (m) el.setAttribute(m[1], m[2]);
        document.head.appendChild(el);
    }
    el.setAttribute(attr, value);
}

/**
 * useSeo — set per-route SEO tags (title, description, canonical, og:*, twitter:*).
 * Falls back to hub defaults for anything not provided.
 */
export default function useSeo({ title, description, image, url } = {}) {
    useEffect(() => {
        const finalTitle = title
            ? `${title} — EIGOO Books Hub`
            : DEFAULTS.title;
        const finalDesc = description || DEFAULTS.description;
        const finalImage = image || DEFAULTS.image;
        const finalUrl =
            url ||
            (typeof window !== "undefined" ? window.location.href : "https://books.eigooinc.net/");

        document.title = finalTitle;
        setMeta('meta[name="description"]', "content", finalDesc);
        setMeta('meta[name="robots"]', "content", "index, follow");
        setMeta('meta[property="og:title"]', "content", finalTitle);
        setMeta('meta[property="og:description"]', "content", finalDesc);
        setMeta('meta[property="og:type"]', "content", "website");
        setMeta('meta[property="og:url"]', "content", finalUrl);
        setMeta('meta[property="og:image"]', "content", finalImage);
        setMeta('meta[name="twitter:card"]', "content", "summary_large_image");
        setMeta('meta[name="twitter:title"]', "content", finalTitle);
        setMeta('meta[name="twitter:description"]', "content", finalDesc);
        setMeta('meta[name="twitter:image"]', "content", finalImage);
    }, [title, description, image, url]);
}
